"use client";

import { useCart } from "@/app/context/web/CartContext";
import { Search, ShoppingBag, User } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function MobileOptions() {
  const pathname = usePathname();

  const { cart } = useCart();

  const menus = [
    {
      title: "Search",
      href: "/products",
      icon: Search,
    },
    {
      title: "Cart",
      href: "/pages/web/cart",
      icon: ShoppingBag,
    },
    {
      title: "Profile",
      href: "/pages/web/profile",
      icon: User,
    },
  ];

  return (
    <section className="md:hidden fixed bottom-3 left-1/2 -translate-x-1/2 z-9999 w-[92%] max-w-sm">
      <div className="flex items-center justify-around h-16 rounded-full bg-white/95 backdrop-blur-xl border border-gray-200 shadow-xl px-2">
        {menus.map((item) => {
          const Icon = item.icon;

          const active = pathname === item.href;

          const isCart = item.title === "Cart";

          return (
            <Link
              key={item.title}
              href={item.href}
              className="group relative flex flex-col items-center justify-center gap-1 flex-1 h-full"
            >
              {/* Icon Wrapper */}
              <div
                className={`
                  relative
                  flex
                  items-center
                  justify-center
                  transition-all
                  duration-300
                  ${
                    active
                      ? "text-[#D4AF37] scale-110"
                      : "text-[#0A2342] group-hover:text-[#D4AF37] group-hover:scale-110"
                  }
                `}
              >
                <Icon size={20} strokeWidth={2} />

                {/* Cart Badge */}
                {isCart && cart.length > 0 && (
                  <span
                    className="
                      absolute
                      -top-2.5
                      -right-2.5
                      min-w-4.5
                      h-4.5
                      px-1
                      rounded-full
                      bg-[#0A2342]
                      text-white
                      text-[9px]
                      font-bold
                      leading-none
                      flex
                      items-center
                      justify-center
                      border-2
                      border-white
                      shadow-md
                      transition-all
                      duration-300
                      group-hover:bg-[#D4AF37]
                      group-hover:text-[#0A2342]
                      group-hover:scale-110
                    "
                  >
                    {cart.length > 99 ? "99+" : cart.length}
                  </span>
                )}
              </div>

              {/* Title */}
              <span
                className={`
                  text-[10px]
                  font-medium
                  transition-colors
                  duration-300
                  ${
                    active
                      ? "text-[#D4AF37]"
                      : "text-[#0A2342] group-hover:text-[#D4AF37]"
                  }
                `}
              >
                {item.title}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
